import { AppDispatch, RootState } from 'app/store';
import axios from 'axios';
import { getAPI } from 'services/api/apiAsync';
import api from 'services/api/apiInstance';
import {
  setCriticalNotificationsData,
  setCriticalNotificationsLoadStatus,
} from 'services/misc/criticalNotificationSlice';
import { selectToken } from 'services/session/sessionSelectors';
import {
  API_ENDPOINTS,
  smartyAddressUrl,
  smartyEmbeddedKey,
} from 'utils/constants';
import { LooseObjectType, SelectOptionType } from 'utils/globalTypes';

export function scanPassword(password: string) {
  return async (dispatch: AppDispatch) => {
    try {
      const encodedPassword = encodeURIComponent(password);
      const config = {
        url: `${API_ENDPOINTS.passwordScan}/${encodedPassword}`,
      };
      const response = await dispatch(getAPI(config)).unwrap();
      return response;
    } catch (error) {
      // return { noOfTimesAppeared: 2342 };
      return Promise.reject(error);
    }
  };
}

/**
 * Function to fetch the list of US states from the back-end service
 */
export async function fetchUSStates(): Promise<SelectOptionType[]> {
  try {
    const response = await api({
      url: API_ENDPOINTS.statesOfUS,
      method: 'get',
    });

    return response.data.map((state: LooseObjectType) => ({
      value: state.code,
      label: `${state.code} - ${state.name}`,
    }));
  } catch (error) {
    return [];
  }
}

// function to fetch notifications
export function fetchNotifications() {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      const token = selectToken(getState());
      const config = {
        url: API_ENDPOINTS.notifications,
        headers: {
          'X-XSRF-TOKEN': token,
        },
      };
      const response = await dispatch(getAPI(config)).unwrap();
      dispatch(setCriticalNotificationsData(response));
      dispatch(setCriticalNotificationsLoadStatus(true));
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

// function to verify participation token
export function getEnrollmentInfo(token: string) {
  return async (dispatch: AppDispatch) => {
    try {
      const config = {
        url: `${API_ENDPOINTS.enrollmentInfo}${token}`,
      };

      const response = await dispatch(getAPI(config)).unwrap();

      return !response.status;
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

// function to fetch data from cms
export function fetchDataFromCMS(filePath: string) {
  return async (dispatch: AppDispatch) => {
    try {
      const config = {
        url: `${API_ENDPOINTS.termsOfService}${filePath}`,
        responseType: 'text' as const,
        headers: {
          Accept: 'text/html',
        },
      };
      const response = await dispatch(getAPI(config)).unwrap();

      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

// Smarty address autocomplete
export function searchSmartyAddress(searchParams: LooseObjectType) {
  return async () => {
    try {
      const params = new URLSearchParams({
        key: smartyEmbeddedKey,
        ...searchParams,
      });
      const config = {
        url: `${smartyAddressUrl}?${params.toString()}`,
      };
      const response = await axios.get(config.url);
      return response?.data?.suggestions;
    } catch (error) {
      return Promise.reject(error);
    }
  };
}
